import React, { useRef, useState } from "react";
import api, { imageUrl, formatApiError } from "../lib/api";
import { Upload, Link2, Loader2, ImageIcon } from "lucide-react";
import { toast } from "sonner";

export function ImageUpload({ value, onChange, label = "Image", testId = "image-upload", className = "" }) {
  const fileRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [showUrl, setShowUrl] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  return (
    <div className={className}>
      {label && <label className="text-xs font-medium text-muted-foreground">{label}</label>}
      <div className="mt-1 flex items-start gap-3">
        <div className="w-20 h-20 rounded-lg border border-black/15 bg-beige flex items-center justify-center overflow-hidden shrink-0">
          {value ? (
            <img src={imageUrl(value)} alt="preview" className="w-full h-full object-cover" data-testid={`${testId}-preview`} />
          ) : (
            <ImageIcon size={22} className="text-muted-foreground/50" />
          )}
        </div>
        <div className="flex-1 space-y-2">
          <input ref={fileRef} type="file" accept="image/png,image/jpeg,image/webp,image/gif" onChange={handleFile} className="hidden" data-testid={`${testId}-file`} />
          <div className="flex flex-wrap gap-2">
            <button type="button" onClick={() => fileRef.current?.click()} disabled={uploading} data-testid={`${testId}-btn`}
              className="flex items-center gap-1.5 bg-navy text-cream text-xs font-semibold px-3.5 py-2 rounded-lg hover:bg-navy-soft disabled:opacity-60">
              {uploading ? <Loader2 size={13} className="animate-spin" /> : <Upload size={13} />} {uploading ? "Uploading..." : "Upload image"}
            </button>
            <button type="button" onClick={() => setShowUrl((s) => !s)} data-testid={`${testId}-url-toggle`}
              className="flex items-center gap-1.5 border border-black/15 text-navy text-xs font-medium px-3 py-2 rounded-lg hover:border-gold">
              <Link2 size={13} /> Use URL
            </button>
          </div>
          {showUrl && (
            <input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="https://..." data-testid={`${testId}-url-input`}
              className="w-full border border-black/15 rounded-lg px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-gold" />
          )}
        </div>
      </div>
    </div>
  );
}
